import KeenSlider from 'keen-slider'
import { keyboard, arrows, numbers } from './slider-plugins'

const initSlider = () => {
  const sliders = document.querySelectorAll('.keen-slider')

  if (!sliders?.length) return

  sliders.forEach((slider) => {
    const slideView = slider.classList.contains('js-lightbox')
      ? [2.25, 2, 1.48]
      : [2.215, 2.66, 1.07]

    new KeenSlider(
      slider,
      {
        loop: false,
        drag: true,
        breakpoints: {
          '(min-width: 0)': {
            slides: {
              perView: slideView[0],
            },
          },

          '(max-width: 1440px)': {
            slides: {
              perView: slideView[1],
            },
          },
          '(max-width: 780px)': {
            slides: {
              perView: slideView[2],
            },
          },
        },
      },
      [keyboard, arrows],
    )
  })
}

initSlider()
